module.exports = __webpack_public_path__ + "img/ennetix-solution-requirements.db801019.png";